module.exports = __webpack_public_path__ + "static/media/smile-fail.7666f6bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/smiles/smile-fail.svg
// module id = 147
// module chunks = 0